<div class="{{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="browsers-email-r2">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="o-stack__cell">
				<h5 class="email-linksummary-h5">{{ sectiontitle }}</h5>
				<span *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV()"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
		<div *ngIf="hasData">
			<div class="browser-details" *ngIf="!isR1301 && !isR104">
				<div *ngFor="let browserDetail of browserDetails" class="email_browsers">
					<div class="browser-logo">
						<img [src]="browserDetail.browserLogoPath" />
					</div>
					<div class="description">
						<p class="browser-name">{{ browserDetail.browserName }}</p>
						<p class="clicks">
							{{ browserDetail.formattedClicks }}
						</p>
						<p class="clicks-label" *ngIf="browserDetail.clicks > 1; else elseBlock">clicks</p>
						<ng-template #elseBlock>
							<p class="clicks-label">click</p>
						</ng-template>
					</div>
				</div>
			</div>
			<div class="browser-details" *ngIf="isR1301">
				<div *ngFor="let browserDetail of browserDetails" class="email_browsers">
					<div class="description">
						<p class="browser-name">{{ browserDetail.browserName }}</p>
						<div class="browser-logo">
							<img [src]="browserDetail.browserLogoPath" />
						</div>
						<div class="browser-bar">
							<div
								class="bar"
								[ngStyle]="{
									width: (browserDetail.percentValue > 0 ? browserDetail.percentValue : 0) + '%'
								}"
							>
								''
							</div>
							<p class="clicks">
								{{ browserDetail.formattedClicks }}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="browser-details" *ngIf="isR104">
				<div class="email-browser-header">
					<div class="email-browser-header-1">Network</div>
					<div></div>
					<div class="email-browser-header-2">Clicks</div>
				</div>
				<div class="email_">
					<div *ngFor="let browserDetail of browserDetails" class="email_browsers">
						<div class="description">
							<div class="browser-logo">
								<img [src]="browserDetail.browserLogoPath" />
							</div>
							<p class="browser-name">{{ browserDetail.browserName }}</p>

							<div class="browser-bar">
								<p class="clicks">
									{{ browserDetail.clicks | number }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div class="no-data-email-browser">
				<div class="no-data-text">No Data Available</div>
			</div>
		</div>
	</div>
	<div class="clear"></div>
</div>
